import React, { memo } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import styles from './index.css';


const SideMenuTrigger = (props) => {
  const { onToggle } = props;

  return (
    <IconButton
      className={styles.sideMenuTrigger}
      onClick={onToggle}
    >
      <MenuIcon />
    </IconButton>
  );
};

SideMenuTrigger.propTypes = {
  onToggle: PropTypes.func.isRequired,
};

export default memo(SideMenuTrigger);
